import type { Permission } from '@almacen/shared';
import {
  IconBarcode,
  IconBox,
  IconCurrencyEuro,
  IconFileInvoice,
  IconHistory,
  IconHome,
  IconLayoutGrid,
  IconListDetails,
  IconMapPin,
  IconPackages,
  IconSettings,
  IconTruckDelivery,
  IconTruckLoading,
  IconUserShield,
  IconUsers,
  type Icon,
} from '@tabler/icons-react';

export interface NavItem {
  label: string;
  to: string;
  icon: Icon;
  permission: Permission;
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

/** Menú principal. Cada opción se muestra solo si el rol tiene el permiso. */
export const NAV_SECTIONS: NavSection[] = [
  {
    title: 'Operativa',
    items: [
      { label: 'Inicio', to: '/', icon: IconHome, permission: 'pallets.read' },
      {
        label: 'Entrada de palets',
        to: '/entrada',
        icon: IconTruckDelivery,
        permission: 'pallets.entry',
      },
      { label: 'Ubicar / mover', to: '/ubicar', icon: IconBarcode, permission: 'pallets.locate' },
      { label: 'Salidas', to: '/salidas', icon: IconTruckLoading, permission: 'outbound.manage' },
      {
        label: 'Mapa del almacén',
        to: '/mapa',
        icon: IconLayoutGrid,
        permission: 'locations.read',
      },
    ],
  },
  {
    title: 'Consultas',
    items: [
      { label: 'Inventario', to: '/inventario', icon: IconPackages, permission: 'pallets.read' },
      { label: 'Histórico', to: '/historico', icon: IconHistory, permission: 'pallets.read' },
    ],
  },
  {
    title: 'Datos maestros',
    items: [
      { label: 'Clientes', to: '/clientes', icon: IconUsers, permission: 'clients.read' },
      { label: 'Mercancías', to: '/mercancias', icon: IconBox, permission: 'products.read' },
      {
        label: 'Ubicaciones',
        to: '/ubicaciones',
        icon: IconMapPin,
        permission: 'locations.manage',
      },
    ],
  },
  {
    title: 'Facturación',
    items: [
      { label: 'Tarifas', to: '/tarifas', icon: IconCurrencyEuro, permission: 'rates.read' },
      {
        label: 'Liquidaciones',
        to: '/liquidaciones',
        icon: IconFileInvoice,
        permission: 'billing.read',
      },
    ],
  },
  {
    title: 'Administración',
    items: [
      { label: 'Usuarios', to: '/usuarios', icon: IconUserShield, permission: 'users.manage' },
      {
        label: 'Configuración',
        to: '/configuracion',
        icon: IconSettings,
        permission: 'settings.manage',
      },
      { label: 'Auditoría', to: '/auditoria', icon: IconListDetails, permission: 'audit.read' },
    ],
  },
];
